import React from 'react';

export interface IFmsReferenceFilesContext {
  cancel: () => boolean,
};

const defaultState:IFmsReferenceFilesContext = {
  cancel: () => false,
};

const IFmsReferenceFilesContext = React.createContext<IFmsReferenceFilesContext>(defaultState);

export default IFmsReferenceFilesContext;
